/**
 * Remember to change the property based environemnt, to retrieve informations on ./utils/application/application-settings.ts
 */
export const env = "application-env-prd-univaq";